export default function BlockTitle({ title, labelClick,style }) {
  return (
    <div className={'mdmax:flex 1xl:pt-[100px] md:pt-[50px] mdmax:pt-[25px] 1xl:mb-[50px] mb-[25px] mdmax:mb-[10px] mdmax:items-center'}>
      <h5 className={'md:w-[100%] text-center mdmax:text-left text-3xl mdmax:text-2xl font-bold '} style={style}>{title}</h5>
    </div>
  );
}
